import PrinterSettingModal from "@/Components/Modal/PrinterSettingModal";
import useHasKioskPrinter from "@/shared/atoms/useKioskPrinterAtom";
import useElectronHook from "@/shared/hooks/useElectronHook";
import useThemesHook from "@/shared/hooks/useThemesHook";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import KioskClosedScreen from "./KioskClosedScreen";
import KioskExit from "./KioskExit";
import { KioskThemeWrapper } from "./KioskWrapper";
import useIsKioskClosed from "./useIsKioskClosed";

const Kiosk = ({ children }: any) => {
  useThemesHook();
  const history = useHistory();
  const isClosed = useIsKioskClosed();
  const { isElectron } = useElectronHook();
  const hasKioskPrinter = useHasKioskPrinter();

  const showPrinterModal = isElectron && !hasKioskPrinter && !isClosed;

  useEffect(() => {
    if (isClosed) {
      history.push("/kiosk");
    }
  }, [isClosed]);

  useEffect(() => {
    return () => {
      // every kiosk page mounts its own <Kiosk>; only reset when leaving the kiosk
      if (window.location.pathname.startsWith("/kiosk")) return;
      const root = document.getElementById("root");
      if (!root) return;
      root.style = "";
    };
  }, []);

  return (
    <KioskThemeWrapper>
      <KioskExit />
      {showPrinterModal && <PrinterSettingModal show onExit={() => {}} />}
      {isClosed ? <KioskClosedScreen /> : children}
    </KioskThemeWrapper>
  );
};

export default Kiosk;
